module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_close-14bda15dcc309dd567ad66d3b02b869a.svg";